import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useNavGridClicked = ({
	isAuthorizedZone,
}: {
	isAuthorizedZone: boolean;
}) =>
	useSendEvent(
		events.navigation.navLinkGridClick,
		{
			zone: isAuthorizedZone ? 'auth' : 'non-auth',
		},
		{
			forceSendDemoUser: true,
		}
	);
